/** Copyright 2024 SAP SE or an SAP affiliate company. All rights reserved. */
import React from 'react';
import { Select, Option, Label } from '@ui5/webcomponents-react';
import { useTranslations } from '../hooks/useTranslations';

interface DropdownProps {
    label: string;
    dropdownKey: string;
    selectedValue: string;
    options: string[];
    fullWidth?: boolean;
    handlechange: (event: any, dropdownKey: string) => void;
}

const DropdownComponent: React.FC<DropdownProps> = ({ label, dropdownKey, selectedValue, options, handlechange, fullWidth }) => {
    const labelWidth = label.length > 2 ? '50%' : '30%';
    const selectWidth = label.length === 0 ? '18.75rem' : `calc(100% - ${labelWidth})`;
    const { t } = useTranslations();
    return (
        <div style={{ display: 'flex', alignItems: 'center', width: '100%', justifyContent: 'center' }}>
            {label && (
                <div
                    style={{
                        width: labelWidth,
                        display: 'flex',
                        textAlign: 'right',
                        alignItems: 'center',
                        justifyContent: 'right',
                        paddingBottom: '1rem',
                    }}
                >
                    <Label style={{ paddingRight: '2rem' }} showColon={true}>
                        {label}
                    </Label>
                </div>
            )}
            <div style={{ display: 'flex', alignItems: 'center', width: '100%', justifyContent: 'flex-start', paddingBottom: '1rem' }}>
                <Select
                    style={{ width: fullWidth ? '100%' : selectWidth }}
                    onLiveChange={e => handlechange(e, dropdownKey)}
                    value={selectedValue}
                    data-testid={`select-${dropdownKey}`}
                >
                    <Option value="" data-value="">
                        {t('SELECT')}
                    </Option>
                    {options.map(option => (
                        <Option key={option} value={option} data-value={option} selected={option === selectedValue}>
                            {t(option)}
                        </Option>
                    ))}
                </Select>
            </div>
        </div>
    );
};

export default DropdownComponent;
